import { ModuleWithProviders } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { AboutComponent } from './about.component';
import { TeamComponent } from './team/team.component';
import { ApdiffComponent } from './apdiff/apdiff.component';
import { ContactComponent } from './contact/contact.component';
// import { NewsComponent } from './news/news.component';

export const router: Routes = [
    {path: 'about', component: AboutComponent},
    {path: 'team', component: TeamComponent},
    {path: 'apdiff', component: ApdiffComponent },
    {path: 'contact', component: ContactComponent}
  //  {path: 'news', component: NewsComponent}
  ];

export const routes: ModuleWithProviders<any> = RouterModule.forChild(router);
